import __request__ from "routing/request";
export function regexTester(regex, replacement, replace_all = false, string, requestOptions) {
  return __request__("GET", "/tools/regex_replace_tester", null, { "regex": regex, "replacement": replacement, "replace_all": replace_all, "string": string }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testRegex(JSONbody, requestOptions) {
  return __request__("POST", "/tools/regex_replace_tester", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
